// Userのプロパティ.
export interface User {
  created_at: string;
  functional_latest_date: string;
  institution_sub: string;
  updated_at: string;
  user_birth_year: string;
  user_birth_month: string;
  user_birth_day: string;
  user_care_id: string;
  user_care_level: string;
  user_gender: number;
  user_id: string;
  user_name: string;
  user_name_kana: string;
  user_visit_day: number[];
}

interface InterfaceModel {
  id: string;
  name: string;
  birth_year: string;
  gender: string;
  date: string;
}

// 利用者一覧用モデル.
export const LocomoModel: InterfaceModel = {
  'id': '介護保険番号',
  'name': '名前',
  'birth_year': '生年',
  'gender': '性別',
  'date': '登録日',
};

// 記録用・利用者一覧用モデル.
export const KirokuModel: InterfaceModel = {
  'id': '介護保険番号',
  'name': '名前',
  'birth_year': '生年',
  'gender': '性別',
  'date': '最新の記録日',
};

export const Male: string = '男';
export const Female: string = '女';

export const TypeTraining: number = 1;
// 日常生活動作: 2?
export const TypeKiroku: number = 3;

export const MO: string = 'Mo';
export const TU: string = 'Tu';
export const WE: string = 'We';
export const TH: string = 'Th';
export const FR: string = 'Fr';
export const SA: string = 'Sa';
export const SU: string = 'Su';
export const ALL: string = 'All';

// 曜日.
export const WEEK_CHARS: string[] = [SU, MO, TU, WE, TH, FR, SA];

// 月曜日開始日曜日終わりの曜日達.
export const START_MO_WEEK_CHARS: string[] = [MO, TU, WE, TH, FR, SA, SU];



// WEBPACK FOOTER //
// ./src/constants/UserListField.tsx